<template>
  <div>
    <component
      :is="comName"
      :header="header"
      :ruleMap="ruleMap"
      :rankType="rankType"
      :types="types"
    >
      <slot name="list" :hideType="hideType"/>
    </component>
  </div>
</template>
<script>
import oldHeader from './oldHeader.vue'
import singleHeader from './singleHeader.vue'
import multiHeader from './multiHeader.vue'
import { SINGLE_RANK, MULTI_RANK } from './const.js'
export default {
  name: 'TrendHeaderCom',
  components: {
    oldHeader,
    singleHeader,
    multiHeader
  },
  props: {
    dataType: {
      type: String
    },
    header: {
      type: Object
    },
    ruleMap: {
      type: Object
    },
    rankType:{
      type: [String, Number]
    },
    types: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
    }
  },
  computed: {
    comName() {
      return this.dataType === MULTI_RANK
         ? 'multiHeader'
         : this.dataType === SINGLE_RANK
          ? 'singleHeader'
          : 'oldHeader'
    },
    hideType() {
      return this.dataType === SINGLE_RANK
    }
  }
}
</script>